// import l from '@reaction-localization/mobile'

function getFormattedApiErrorForStatus(status: number): string {
  let error = ''

  // switch (status) {
  //   case 400:
  //     error = l.error_status_400
  //     break
  //   case 403:
  //     error = l.error_status_403
  //     break
  //   case 404:
  //     error = l.error_status_404
  //     break
  //   case 409:
  //     error = l.error_status_409
  //     break
  //   case 429:
  //     error = l.error_status_429
  //     break
  //
  //   case 500:
  //     error = l.error_status_500
  //     break
  //
  //   case 502:
  //   case 503:
  //   case 504:
  //     error = l.error_status_502
  //     break
  //
  //   default:
  //     break
  // }

  return error
}

export default getFormattedApiErrorForStatus
